import { configureStore } from '@reduxjs/toolkit';
import authSlice, { authStateType } from './slice/authSlice';
import adminSlice from './slice/adminSlice';
import userSlice from './slice/userSlice';

export interface storeStateType {
	auth: authStateType;
}

export default configureStore({
	reducer: {
		auth: authSlice.reducer,
		admin: adminSlice.reducer,
		user: userSlice.reducer,
	},
});
